import { ColDef, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import AgGridCustomTable from "../../../../../../../../util/component/AgGridCustomTable";
import { useBookingAttachmentsQuery } from "../../../../../../api/services";
import { IBookingAttachment, RouteParams, TypeAsset } from "../../../../../../types";
import AttachmentsActionsCell from "./AttachmentsActionsCell";
import CustomLoader from "../../../../../../../../util/component/CustomLoader";

export type AttachmentsTableData = IBookingAttachment;

const TableAttachments = () => {

    const { id } = useParams<RouteParams>();

    const { t } = useTranslation('booking');

    const attachmentsQuery = useBookingAttachmentsQuery(
        id,
        {
            refetchOnMount: false
        }
    );

    const columnDefs = useMemo<ColDef<AttachmentsTableData>[]>(() => [
        {
            field: '_actions',
            headerName: '',
            resizable: false,
            pinned: 'right',
            maxWidth: 100,
            minWidth: 100,
            cellStyle: {
                display: 'flex',
                alignItems: 'center'
            },
            cellRenderer: AttachmentsActionsCell
        },
        {
            field: 'name',
            headerName: t('label.name')
        },
        {
            field: 'user',
            headerName: t('label.user'),
            valueGetter: (params: ValueGetterParams<AttachmentsTableData>) => params.data?.creationOperator.username
        },
        {
            field: 'creationDateTime',
            headerName: t('label.uploadDate'),
            valueFormatter: (params: ValueFormatterParams<AttachmentsTableData>) => dayjs(params.data?.creationDateTime).format('DD-MM-YYYY HH:mm')
        },
        {
            field: 'type',
            headerName: t('label.type'),
            valueFormatter: (params: ValueFormatterParams<AttachmentsTableData>) => !!params.data?.type ? t(`asset_type.${params.data?.type}`)  : t(`asset_type.${TypeAsset.OTHER}`)

        }
    ], [t]);
    const defaulColDef = useMemo<ColDef<AttachmentsTableData>>(() => ({
        resizable: true,
        lockPinned: true,
        suppressMovable: true
    }), []);

    return (
        <>
            <AgGridCustomTable<AttachmentsTableData>
                height="500px"
                columnDefs={columnDefs}
                defaultColDef={defaulColDef}
                rowData={attachmentsQuery.data}
                pagination={false}
                suppressDragLeaveHidesColumns
            />
            <CustomLoader loading={attachmentsQuery.isLoading} />
        </>
    )
};

export default TableAttachments;
